/* istanbul ignore file */

const getInternal = () =>
    Object.freeze({
        PRODUCTION: process.env.NODE_ENV === "production",
        DEVELOPMENT: process.env.NODE_ENV === "development",
        DEV_URL_OVERRIDE: process.env.DEV_URL_OVERRIDE || "",
        NODE_ENV: process.env.NODE_ENV,
        REACT_APP_BLOB_STORAGE_PATH: "/static-content",
        REACT_APP_ENABLE_CYPRESS_SETTINGS: process.env.REACT_APP_ENABLE_CYPRESS_SETTINGS || false,
    })

const INTERNAL = getInternal()

const getEnvVars = () =>
    Object.freeze({
        REACT_APP_BLOB_STORAGE_SSR_BASEURL:
            process.env.REACT_APP_BLOB_STORAGE_SSR_BASEURL || "https://ecmbrowsefdsxeuw.azurefd.net",
        PORT: process.env.PORT || 3001,
        REACT_APP_CDN_BASEURL: process.env.REACT_APP_CDN_BASEURL
            ? process.env.REACT_APP_CDN_BASEURL
            : "https://xcdn.next.co.uk/content",
        REACT_APP_API_BASEURL: process.env.REACT_APP_API_BASEURL
            ? process.env.REACT_APP_API_BASEURL
            : "https://ci-test.next.co.uk/api/product-summary",
        REACT_APP_API_BASEURL_PRODUCT_AGGREGATOR:
            process.env.REACT_APP_API_BASEURL_PRODUCT_AGGREGATOR || "https://ci-test.next.co.uk/api/product-aggregator",
        REACT_APP_API_BASEURL_STOCK: process.env.REACT_APP_API_BASEURL_STOCK || "https://ci-test.next.co.uk/api/stock",
        POD_NAME: process.env.POD_NAME,
        REACT_APP_SERVE_PATH_PREFIX: process.env.REACT_APP_SERVE_PATH_PREFIX || "",
        ASSETS_PATH: process.env.ASSETS_PATH || "/productsummarystatic",
        LOG_LEVEL: process.env.LOG_LEVEL,
        FNC_NAME: process.env.FNC_NAME,
        REACT_APP_APPINSIGHTS_KEY: process.env.REACT_APP_APPINSIGHTS_KEY,
        REACT_APP_USE_TIME_MACHINE_COOKIE: process.env.REACT_APP_USE_TIME_MACHINE_COOKIE || "false",
        ENVIRONMENT_NAME: process.env.ENVIRONMENT_NAME,
        REACT_APP_LAUNCH_DARKLY_APP_ID: process.env.REACT_APP_LAUNCH_DARKLY_APP_ID || "sx-launch-darkly-app-id",
        REACT_APP_LAUNCH_DARKLY_SDK_KEY: process.env.REACT_APP_LAUNCH_DARKLY_SDK_KEY,
        REACT_APP_LAUNCH_DARKLY_BASE_URI: process.env.REACT_APP_LAUNCH_DARKLY_BASE_URI,
        REACT_APP_LAUNCH_DARKLY_EVENTS_URI: process.env.REACT_APP_LAUNCH_DARKLY_EVENTS_URI,
        REACT_APP_LAUNCH_DARKLY_STREAM_URI: process.env.REACT_APP_LAUNCH_DARKLY_STREAM_URI,
    })

export const getVars = () => ({...INTERNAL, ...getEnvVars()})

export default getVars()
